import { useSuspenseQuery } from '@tanstack/react-query'
import { FolderCheckIcon } from 'lucide-react'

import { getUserQuery } from '@/lib/queries/business/v2/user/queries'

import { numberFormatter } from '../constants'

export const ActiveCasesContent = () => {
  const { data: dataUser } = useSuspenseQuery(getUserQuery)

  if (!dataUser) {
    return null
  }

  const currentCases = dataUser.extraProductInfo.currentCases
  const numMaxCases = dataUser.extraProductInfo.maxCases

  return (
    <>
      <span>
        <FolderCheckIcon size={16} />
      </span>
      <div className="text-xs text-muted-foreground">
        Active {numberFormatter.format(currentCases)}&nbsp;/&nbsp;
        {numberFormatter.format(numMaxCases)}
      </div>
    </>
  )
}
